import { HELP_CENTER_URL } from '@/env'

export const paths = {
  home: {
    path: '/',
    getHref: () => '/',
  },

  technician: {
    profile: {
      path: 't/:slug',
      getHref: (slug: string, fromOnboarding?: boolean) => `/t/${slug}${fromOnboarding ? '?fromOnboarding=true' : ''}`,
    },
  },
  onboarding: {
    path: 'onboarding',
    getHref: () => '/onboarding',
  },
  auth: {
    register: {
      path: '/auth/register',
      getHref: (redirectTo?: string | null | undefined) =>
        `/auth/register${redirectTo ? `?redirectTo=${encodeURIComponent(redirectTo)}` : ''}`,
    },
    login: {
      path: '/auth/login',
      getHref: (redirectTo?: string | null | undefined) =>
        `/auth/login${redirectTo ? `?redirectTo=${encodeURIComponent(redirectTo)}` : ''}`,
    },
    'password-reset': {
      path: '/auth/password-reset',
      getHref: () => '/auth/password-reset',
    },
    'update-password': {
      path: '/auth/update-password',
      getHref: () => '/auth/update-password',
    },
  },

  app: {
    root: {
      path: '/app',
      getHref: () => '/app',
    },
    services: {
      path: 'services',
      getHref: () => '/app/services',
    },
    service: {
      path: 'service/:serviceId',
      getHref: (id: string) => `/app/service/${id}`,
    },
    'create-service': {
      path: 'create-service/:templateId?',
      getHref: (templateId?: string) => (templateId ? `/app/create-service/${templateId}` : '/app/create-service'),
    },
    'service-questions': {
      path: 'service-questions',
      getHref: () => '/app/service-questions',
    },
    orders: {
      path: 'orders',
      getHref: (practicianName?: string) =>
        `/app/orders${practicianName ? `?pn=${encodeURIComponent(practicianName)}` : ''}`,
    },
    order: {
      path: 'order/:orderId',
      getHref: (id: string) => `/app/order/${id}`,
    },
    'new-order': {
      path: 'new-order/:serviceId',
      getHref: (id: string) => `/app/order/new-order/${id}`,
    },
    'new-order-solo': {
      path: 'order/solo/new',
      getHref: () => '/app/order/solo/new',
    },
    'my-patients': {
      path: 'my-patients',
      getHref: () => '/app/my-patients',
    },
    'my-technicians': {
      path: 'my-technicians',
      getHref: () => '/app/my-technicians',
    },
    'search-service': {
      path: 'search-service',
      getHref: ({ query, technicianDisplayName }: { query?: string; technicianDisplayName?: string }) => {
        const base = `/app/search-service`
        const searchParams = new URLSearchParams()
        if (query) searchParams.append('query', query)
        if (technicianDisplayName) searchParams.append('tdn', technicianDisplayName)
        return `${base}?${searchParams.toString()}`
      },
    },
    settings: {
      path: 'settings',
      getHref: (tab?: string) => `/app/settings${tab ? `?tab=${encodeURIComponent(tab)}` : ''}`,
    },
    notifications: {
      path: 'notifications',
      getHref: () => '/app/notifications',
    },
  },
  extra: {
    help: {
      path: HELP_CENTER_URL,
      getHref: () => HELP_CENTER_URL,
    },
    'privacy-policy': {
      path: 'privacy-policy',
      getHref: () => '/app/privacy-policy',
    },
  },
} as const
